module.exports = __webpack_public_path__ + "static/img/11.d6aeaf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/11.png
// module id = c1go
// module chunks = 0